<input
  #phoneInput
  class="phone-number-input {{ interactionState$ | async }}"
  type="tel"
  [attr.id]="controlId"
  [class.form-error-border]="error"
  [attr.aria-invalid]="error ? true : null"
  [maskito]="maskOptions"
  [value]="displayValue"
  [disabled]="isDisabled"
  (input)="handleInput($event)"
  (focus)="onFocus()"
  (blur)="onBlur()" />
